import React from 'react';
import { ListingObjects } from 'hyperdb-utils';
import { HyperdbListing } from '../../../../hyperdb';

class Listing extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    // TODO
    const clientId = JSON.parse(localStorage.getItem('currentUser')).client_id;
    const zones = (this.props.objects.zones || []).filter(zone => {
      const barcelonaId = '18425409708756';
      return clientId === '3912abc1' || clientId === '12345678' ? zone.id === barcelonaId : zone.id !== barcelonaId;
    });
    const objects = { ...this.props.objects, zones };
    return (
      <ListingObjects
        { ...this.props }
        objects={ objects }
      />
    );
  }
}

export default HyperdbListing({
  CustomComponent: Listing,
  collectionName: 'zones',
  namespace: 'zone',
  mountedUrl: '/zones',
  title: 'Zones',
  columns: [
    { attribute: 'name' },
    { attribute: 'country.name', label: 'country' },
  ],
  canCreate: false,
  canDelete: false,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/zone/containers/Listing.jsx